module.exports = __webpack_public_path__ + "static/media/peliculas-card.37040ce9.svg";